import { DatesRangeValue } from '@mantine/dates';
import moment from 'moment';
import { useState } from 'react';

/**
 * Date-range state defaulting to the last `days` days (inclusive of today).
 * Shared by every AI Assistant admin view so "last 30 days" means the same
 * thing on Overview and the per-user drill-down.
 */
export const useDefaultDateRange = (
  days = 30,
): [DatesRangeValue, (value: DatesRangeValue) => void] => {
  const [range, setRange] = useState<DatesRangeValue>([
    moment()
      .subtract(days - 1, 'days')
      .startOf('day')
      .toDate(),
    moment().endOf('day').toDate(),
  ]);

  return [range, setRange];
};
